<template>
  <li class="lineup__productLi">
    <a :data-remodal-target="'modal-lineup-'+item.id" :href="'#modal-lineup-'+item.id">
      <dl>
        <dt :class=icon><img class="js-lineup__random--12" :src="item.img.model" :alt="item.num"></dt>
        <dd>
          <div class="lineup__productPhoto">
            <img :style="{'animation-duration':rndanim}" class="js-lineup__random--12" :src="item.img.main" alt="">
            <img :style="{'animation-duration':rndanim}" class="js-lineup__random--12b" :src="item.img.sub" alt="">
          </div>
        </dd>
      </dl>
    </a>
  </li>
</template>

<script>

export default {
  name: 'ListItem',
  props: ['item'],
  // props: {
  //   item: {
  //     type: Object,
  //   },
  // },
  computed : {
    rndanim: function(){
      let rnd = 5 + Math.floor(Math.random() * 20);
      return rnd + 's';
    },
    icon : function(){
      return 'lineup__productLiIcon lineup__productLiIcon--' + this.item.mat;
    },
  }
}
</script>

<style>
</style>
